import { useMemo } from "react";
import { type TokenWithMonitoring } from "@/features/auth/hooks/useApiToken";

interface UseTokenValidationProps {
  apiToken?: string | null;
  selectedToken?: TokenWithMonitoring | null;
  showTokenDropdown?: boolean;
  additionalValidation?: () => boolean;
}

export const useTokenValidation = ({
  apiToken,
  selectedToken,
  showTokenDropdown = false,
  additionalValidation,
}: UseTokenValidationProps) => {
  const isTokenValid = useMemo(() => {
    // If token dropdown is shown, require selectedToken
    if (showTokenDropdown) {
      return !!selectedToken?.token;
    }
    // Otherwise, use apiToken
    return !!apiToken;
  }, [apiToken, selectedToken?.token, showTokenDropdown]);

  const isLaunchDisabled = useMemo(() => {
    if (!isTokenValid) return true;
    if (additionalValidation) return !additionalValidation();
    return false;
  }, [isTokenValid, additionalValidation]);

  const getEffectiveToken = useMemo(() => {
    return selectedToken?.token || apiToken || null;
  }, [selectedToken?.token, apiToken]);

  return {
    isTokenValid,
    isLaunchDisabled,
    effectiveToken: getEffectiveToken,
  };
};
